const validAppearancesFilter = (appearances, includeHappening = false) => {
  // Checks if appearance is published, and if corresponding happening is published (if given, onl needed for nested relations)
  return appearances.filter(Boolean)
    .filter((item) => item.status && (typeof item.fieldHappening !== "undefined" ? item.fieldHappening?.status : true));
}

export default validAppearancesFilter;
